import { useRef, useState } from 'react'
import LayoutPublic from '../component/web/layout/layoutPublic'
import Dialog, { DialogType } from '../control/dialog/dialog'
import useTranslate from '../i18n/useTranslate'
import useActivate, { FormType } from '../services/um/useActivate'
import Form from '../component/authen/activate/Form'
import { useHistory, useLocation } from 'react-router-dom'
import { RoutePath } from '../router/routesConfig'
import { verify } from './Activate'
import { Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core'

const ActivateForgot = () => {
    const translate = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const classes = useStyles()
    const { postActivate } = useActivate()

    const dialogTwoRef = useRef<Record<string, Function>>()

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }
    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const [isShowPassword, setIsShowPassword] = useState(false)
    const [isShowPasswordCf, setIsShowPasswordCf] = useState(false)

    const URL = new URLSearchParams(location.search)
    const token = URL.get('token')

    const decrypt =
        token &&
        verify({
            payload: token,
            secretOrPublicKey: `F04507DDB0103B7D206FBCBD212ED26D74484430`,
            options: {},
        })

    const save = async (values: FormType) => {
        const result = await postActivate(decrypt?.decoded.id, values.password)
        if (result.message === 'not found') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
                onAfterClose: () => goToLogin(),
            })
            dialogTwoRef.current?.openDialog()
            return
        }
        if (result) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: () => goToLogin(),
            })
            dialogTwoRef.current?.openDialog()
        }

        return result
    }

    const onSubmit = async (values: FormType) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onSwitchShow = () => {
        setIsShowPassword(!isShowPassword)
    }
    const onSwitchShowCf = () => {
        setIsShowPasswordCf(!isShowPasswordCf)
    }

    const goToLogin = () => {
        history.push(RoutePath.login)
    }

    return (
        <>
            <LayoutPublic>
                <Container maxWidth="md" className={classes.rootContainer}>
                    <div style={{ display: 'grid', justifyContent: 'center', alignContent: 'center' }}>
                        <Grid container justify="center" alignContent="center" className={classes.root}>
                            <Grid item xs={12} md={10} lg={8} className={classes.item}>
                                <Paper className={classes.paper}>
                                    <Grid container className={classes.container}>
                                        <Grid item xs={12}>
                                            <img
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    '/img/Chulalongkorn_University_Alt_Logo.svg.png'
                                                }
                                                width={'auto'}
                                                height={'60px'}
                                                alt="chula"
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography className={classes.typo}>
                                                {translate.get('UM.ACTIVATE.TITLE')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Form
                                                isShowPassword={isShowPassword}
                                                isShowPasswordCf={isShowPasswordCf}
                                                onClickShowPassword={onSwitchShow}
                                                onClickShowPasswordCf={onSwitchShowCf}
                                                onClickSubmit={onSubmit}
                                                email={decrypt?.decoded.email}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </LayoutPublic>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    rootContainer: {
        display: 'flex',
        alignItems: 'center',
        minHeight: 'calc(100vh - 96px)',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
            padding: '0px',
        },
    },
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    item: {
        [theme.breakpoints.down('sm')]: {
            height: '100%',
        },
    },
    paper: {
        width: '100%',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
        },
    },
    container: {
        padding: '1.5rem',
    },
    typo: {
        fontWeight: 'bold',
    },
}))

export default ActivateForgot
